export function listingsScrollRestoreKey(pathname: string, _search?: string): string {
  return `restoreScrollY:${pathname}`;
}

export function saveListingsScrollY(
  pathname: string,
  search: string,
  y: number,
): void {
  try {
    sessionStorage.setItem(
      listingsScrollRestoreKey(pathname, search),
      String(y),
    );
  } catch {
    // ignore
  }
}

export function hasPendingListingsScrollRestore(
  pathname: string,
  search: string,
): boolean {
  try {
    return (
      sessionStorage.getItem(listingsScrollRestoreKey(pathname, search)) != null
    );
  } catch {
    return false;
  }
}

export function peekListingsScrollRestore(
  pathname: string,
  search: string,
  stateY?: number,
): number | null {
  if (stateY != null && Number.isFinite(stateY)) {
    return stateY;
  }
  try {
    const raw = sessionStorage.getItem(listingsScrollRestoreKey(pathname, search));
    if (raw == null) return null;
    const y = Number(raw);
    return Number.isFinite(y) ? y : null;
  } catch {
    return null;
  }
}

export function consumeListingsScrollRestore(
  pathname: string,
  search: string,
  stateY?: number,
): number | null {
  const key = listingsScrollRestoreKey(pathname, search);
  const y = peekListingsScrollRestore(pathname, search, stateY);
  if (y == null) return null;
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
  return y;
}

/** Run after paint so Layout scroll-to-top does not win the race. Retry for iOS. */
export function applyListingsScrollRestore(y: number): () => void {
  const apply = () => {
    window.scrollTo({ top: y, left: 0, behavior: "auto" });
  };
  const raf = requestAnimationFrame(() => {
    requestAnimationFrame(apply);
  });
  const t1 = window.setTimeout(apply, 80);
  const t2 = window.setTimeout(apply, 320);
  const t3 = window.setTimeout(apply, 800);
  return () => {
    cancelAnimationFrame(raf);
    window.clearTimeout(t1);
    window.clearTimeout(t2);
    window.clearTimeout(t3);
  };
}
